module.exports = __webpack_public_path__ + "static/media/ins14.0a5d078d.jpg";